import React from "react";
import "./css/PrivacyPolicy.css"; // optional external CSS for styling

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <header className="privacy-hero">
        <div className="overlay">
          <h1>Privacy Policy</h1>
          <p>Last Updated: October 17, 2025</p>
        </div>
      </header>

      <main className="privacy-content">
        <section>
          <p>
            At <strong>Web Solution USA</strong> (accessible at{" "}
            <a href="https://www.websolutionusa.com" target="_blank" rel="noopener noreferrer">
              www.websolutionusa.com
            </a>
            ), your privacy is extremely important to us. This Privacy Policy explains how we
            collect, use, and protect your personal information when you visit our website or use
            our services.
          </p>
        </section>

        <section>
          <h2>1. Information We Collect</h2>
          <p>We collect information to provide better services to all our clients. The types of data we may collect include:</p>
          <ul>
            <li><strong>Personal Information:</strong> Name, email address, phone number, company name, and other contact details submitted through our contact or quote forms.</li>
            <li><strong>Website Usage Data:</strong> Information such as your IP address, browser type, pages visited, and time spent on our site (collected via cookies or analytics tools).</li>
            <li><strong>Payment Information:</strong> Billing details or payment method information through our secure payment partners.</li>
            <li><strong>Communication Records:</strong> Emails, messages, or phone call details when you contact us for support or inquiries.</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>Providing and managing our web design, hosting, and digital marketing services.</li>
            <li>Responding to your inquiries, quotes, and support requests.</li>
            <li>Processing payments securely.</li>
            <li>Improving our website and services based on user feedback and analytics.</li>
            <li>Sending updates, promotions, or important service notifications (you can opt out anytime).</li>
          </ul>
        </section>

        <section>
          <h2>3. Sharing of Information</h2>
          <p>
            We do not sell or rent your personal data to third parties. We may share limited information only in the following cases:
          </p>
          <ul>
            <li>With trusted service providers who help operate our business (e.g., hosting, email marketing, or payment gateways).</li>
            <li>To comply with legal obligations or protect our rights.</li>
            <li>In the event of a merger or acquisition, where your data may be transferred to the new entity.</li>
          </ul>
          <p>All third parties are required to handle your information securely and use it only for authorized purposes.</p>
        </section>

        <section>
          <h2>4. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar technologies to enhance your browsing experience and analyze website performance. You can disable cookies in your browser settings, but some parts of the website may not function properly without them.
          </p>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, please note that no method of data transmission over the Internet is 100% secure.
          </p>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access and receive a copy of your personal data.</li>
            <li>Request corrections or deletion of inaccurate information.</li>
            <li>Withdraw consent for marketing communications.</li>
          </ul>
          <p>To exercise these rights, please contact us at <a href="mailto:sales@websolutionusa.com">sales@websolutionusa.com</a>.</p>
        </section>

        <section>
          <h2>7. Third-Party Links</h2>
          <p>
            Our website may contain links to other websites. We are not responsible for the privacy practices or content of those third-party sites.
          </p>
        </section>

        <section>
          <h2>8. Children’s Privacy</h2>
          <p>
            Our services are not directed toward individuals under 18 years of age, and we do not knowingly collect personal data from minors.
          </p>
        </section>

        <section>
          <h2>9. Updates to This Policy</h2>
          <p>
            We may update this Privacy Policy periodically to reflect changes in our business or legal requirements. Any updates will be posted on this page with a revised “Last Updated” date.
          </p>
        </section>

        <section>
          <h2>10. Contact Us</h2>
          <address>
            <strong>Web Solution USA</strong><br />
            📍 8 The Green #16439, Dover, DE 19901<br />
            📧 <a href="mailto:sales@websolutionusa.com">sales@websolutionusa.com</a><br />
            📞 +1 (302) 208 6030
          </address>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
